const dashboard = {
  en: {
    titleAgents: "Agents",
    titleAbilities: "Abilities",
    titleAdversaries: "Adversaries",
    titleAttack: "Attacks",
    topTechniques: "Top techniques",
    textAgents: "Manage your agent codes",
    textAbilities: "Check out our abilities",
    textAdversaries: "Meet our adversaries",
    textEmptyAdversaryMostUsed: "No Adversary has been used yet",
    textEmptyNewAdversary: "No Adversary has been created yet",
    textEmptyMostUsedAbilities: "No Abilities has been used yet",
    textAttack: "Start an attack",
    buttonAgents: "Go to Agents",
    buttonAbilities: "Go to Abilities",
    buttonAdversaries: "Go to Adversaries",
    buttonAttack: "Go to Attack",
    tutorial: "Tutorial",
    guide: "Guide",
    done: "Done",
    emptyList: {
      attack: "There are no registered attacks",
      newAttack: "There are no attacks currently happening right now"
    },
    mostUsed: "Most used",
    new: "New",
    creation: "Creation",
    mitre: {
      title: "Mitre Attack Update",
      version: "Version",
      startDate: "Start Date",
      data: "Data"
    }
  },
  pt: {
    titleAgents: "Agentes",
    titleAbilities: "Habilidades",
    titleAdversaries: "Adversários",
    titleAttack: "Ataques",
    topTechniques: "Top técnicas",
    textAgents: "Gere seus códigos de agente",
    textAbilities: "Confira nossas habilidades",
    textAdversaries: "Conheça nossos adversários",
    textEmptyAdversaryMostUsed: "Nenhum Adversário foi usado ainda",
    textEmptyNewAdversary: "Nenhum Adversário foi criado ainda",
    textEmptyMostUsedAbilities: "Nenhuma habilidade foi usada ainda",
    textAttack: "Começar um ataque",
    buttonAgents: "Vá para Agentes",
    buttonAbilities: "Vá para Habilidades",
    buttonAdversaries: "Vá para Adversários",
    buttonAttack: "Vá para Ataque",
    tutorial: "Tutorial",
    guide: "Guia",
    done: "Feito",
    emptyList: {
      attack: "Não há ataques cadastrados",
      newAttack: "Não há ataques ocorrendo no momento"
    },
    mostUsed: "Mais usados",
    new: "Novo",
    creation: "Criação",
    mitre: {
      title: "Mitre Attack Update",
      version: "Versão",
      startDate: "Data Inicial",
      data: "Dados"
    }
  },
  es: {
    titleAgents: "Agentes",
    titleAbilities: "Habilidades",
    titleAdversaries: "Adversarios",
    titleAttack: "Ataques",
    topTechniques: "Técnicas principales",
    textAgents: "Administre sus códigos de agente",
    textAbilities: "Consulte nuestras habilidades",
    textAdversaries: "Conozca a nuestros adversarios",
    textEmptyAdversaryMostUsed: "Aún no se ha utilizado ningún Adversario",
    textEmptyNewAdversary: "Aún no se ha creado ningún adversario",
    textEmptyMostUsedAbilities: "Aún no se ha utilizado ninguna habilidad",
    textAttack: "Iniciar un ataque",
    buttonAgents: "Ir a Agentes",
    buttonAbilities: "Ir a Habilidades",
    buttonAdversaries: "Ir a Adversarios",
    buttonAttack: "Ir a Ataque",
    tutorial: "Tutorial",
    guide: "Guía",
    done: "Hecho",
    emptyList: {
      attack: "No se han registrado ataques",
      newAttack: "En este momento no se están produciendo ataques"
    },
    mostUsed: "Más usados",
    new: "Nuevo",
    creation: "Creación",
    mitre: {
      title: "Mitre Attack Update",
      version: "Versión",
      startDate: "Fecha de inicio",
      data: "Datos"
    }
  }
}
export default dashboard
